import React/*, { Component }*/ from 'react';
import Constants from "../constants";
import {Col} from "reactstrap";

class KeyboardElement extends React.Component{

    onDown = () => {
        if(this.props.value !== Constants.INPUT_BACKSPACE){
            return;
        }

        clearTimeout(this.clearTimeout);
        this.clearTimeout = setTimeout(()=>{
            this.props.inputCallback(Constants.INPUT_CLEAR);
            if(window.navigator.vibrate) window.navigator.vibrate(100);

        }, 1000)
    };

    onUp = () => {
        clearTimeout(this.clearTimeout);
    };

    onClick = () =>{
        if(window.navigator.vibrate) window.navigator.vibrate(5);
        this.props.inputCallback(this.props.value)
    };

    render(){
        return <Col
            xs={this.props.spanSize}
            className={"noselect keyboard-element"}
            onTouchStart={this.onDown}
            onTouchEnd={this.onUp}
            onMouseDown={this.onDown}
            onMouseUp={this.onUp}
            onClick={this.onClick}>
            <div className={"unclickable"}>
                {this.props.innerElement}
            </div>
        </Col>
    }
}
export default KeyboardElement